import { render, staticRenderFns } from "./living_wap_preview.vue?vue&type=template&id=518902dc&scoped=true&"
import script from "./living_wap_preview.vue?vue&type=script&lang=js&"
export * from "./living_wap_preview.vue?vue&type=script&lang=js&"
import style0 from "./living_wap_preview.vue?vue&type=style&index=0&id=518902dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518902dc",
  null
  
)

export default component.exports